export function plugWeglot() {

    if (typeof Weglot === 'undefined') return;

    if(Weglot.initialize) {
        Weglot.options.dynamics.push({ value: ".widereview-mini" }, ({ value: ".widereview" }))
    }
    else {
        Weglot.initialize( {
            api_key:Weglot.options.api_key,
            dynamic: ".widereview, .widereview-mini"
        });
    }
}
